import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Footer from "./Footer";
import uploadAndDownloadService from "../../services/uploadAndDownloadFile";
import getCurrentUserImages from "../../reduxSaga/sagas/requests/currenImageURL";
import { useRef } from "react";
import UtilsUrl from "../../utils/UtilsUrl";
// import { ReactComponent as BomIcon } from "../resources/icons/bom.svg";
import "../../utils/Css/Style.css";
import "./MenuNoryx.css";
const Menu = (props) => {
  const [showElement, setShowElement] = useState([]);
  const [fullName, setFullName] = useState("");
  const [image, setImage] = useState(null);
  const [userRole, setUserRole] = useState("");

  useEffect(() => {
    const status = localStorage.getItem("status");
    if (status === null) {
      setUserRole(["notConnected"]);
    } else {
      setUserRole(JSON.parse(status));
    }
  }, []);
  useEffect(() => {
    const intervalId = setInterval(() => {
      // Check if image is null
      if (!image) {
        const fileUrl = localStorage.getItem("fileUrl");
        if (fileUrl) {
          setImage(fileUrl); // Set image if fileUrl exists
          clearInterval(intervalId); // Clear the interval once image is found
        }
      }
    }, 100);

    // Cleanup interval on component unmount
    return () => clearInterval(intervalId);
  }, [image]); // Dependency on 'image'
  const myRefs = useRef(null);

  useEffect(() => {
    let user = JSON.parse(localStorage.getItem("user"));
    if (localStorage.getItem("status") == null) {
      setShowElement(["notConnected"]);
    } else {
      setShowElement(JSON.parse(localStorage.getItem("status")));

      uploadAndDownloadService
        .downloadFile(user?.token.urlImage)
        .then((response) => {
          let base64ImageString = Buffer.from(response.data, "binary").toString(
            "base64"
          );

          let image = "data:image/png;base64," + base64ImageString;

          //  setProfileImage(image);
          myRefs.current.src = image;
        })
        .catch(() => { });
      // }
    }
  }, []);

  const initialState = {
    Tiers: false,
    UserAccess: false,
    Product: false,
    Depot: false,
    Sale: false,
    Purchase: false,
    Marketing: false,
    Rh: false,
    Finance: false,
    Production: false,
    Ressouces: false,
    SubProduction: false,
    Integration: false,
    Accounts: false,
    FinanceSales: false,
    Salaires: false,
    FicheDePaies: false,
    wallets: false,
    Settings: false,
    SalaireFicheDePaies: false,
    ClientCommercial: false,
    INVENTAIRE: false,
    CCB2B: false,
  };

  const [menuState, setMenuState] = useState(initialState);

  const createToggleMenuHandler = (menuState, setMenuState, menuName) => {
    return () => {
      setMenuState((prevState) => ({
        ...prevState,
        [menuName]: !prevState[menuName],
      }));
    };
  };

  return (
    // sidebar-collapse sidebar-closed
    <body className="hold-transition sidebar-mini layout-fixed layout-navbar-fixed  layout-footer-fixed ">
      <div className="wrapper">
        <aside className="main-sidebar sidebar-dark-primary elevation-6">
          <a href="/" className="brand-link">
            <img
              src={`${process.env.PUBLIC_URL}/noryx-icon.png`}
              alt="NORYX"
              className="brand-image"
            />
            <span className="brand-text font-weight-light">NORYX</span>
          </a>
          <div className="sidebar">
            {showElement[0] === "notConnected" && (
              <nav className="mt-2">
                <ul
                  className="nav nav-pills nav-sidebar flex-column"
                  data-widget="treeview"
                  role="menu"
                  data-accordion="false"
                >
                  <li className="nav-item">
                    <ul className="nav nav-treeview"></ul>
                  </li>
                  <li className="nav-item">
                    <a href="#" className="nav-link">
                      <i className="nav-icon fas fa-chart-pie" />
                      <p>Accueil</p>
                    </a>
                  </li>
                  <li className="nav-item">
                    <a href="#" className="nav-link">
                      <i className="nav-icon fas fa-chart-pie" />
                      <p>Services</p>
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link">
                      <i className="nav-icon fas fa-chart-pie" />
                      <p>Contactez IWARE</p>
                    </a>
                  </li>

                  <li className="nav-item">
                    <a href="#" className="nav-link">
                      <i className="nav-icon fas fa-chart-pie" />
                      <p>Demos</p>
                    </a>
                  </li>
                </ul>
              </nav>
            )}
            {showElement[0] !== "notConnected" && (
              <nav className="mt-2 ">
                <ul
                  className="nav nav-pills nav-sidebar flex-column"
                  data-widget="treeview"
                  role="menu"
                  data-accordion="false"
                >
                  <li className="nav-item">
                    <ul className="nav nav-treeview"></ul>
                  </li>
                  {showElement.includes("ADMIN") && (
                    <li className="nav-item">
                      <Link to="/maSociete" className="nav-link">
                        <i className="nav-icon fas fa-building" />
                        <p>Ma société</p>
                      </Link>
                    </li>
                  )}
                  {showElement.includes("ADMIN") && (
                    <>
                      <li className="nav-item">
                        <div
                          className="nav-link"
                          onClick={createToggleMenuHandler(
                            menuState,
                            setMenuState,
                            "Integration"
                          )}
                        >
                          <i className="nav-icon fas fa-solid fa-building"></i>
                          <p>
                            Integration
                            <i
                              className={`right fas fa-angle-${
                                menuState["Integration"] ? "down" : "left"
                              }`}
                            />
                          </p>
                        </div>

                        <ul
                          className={`nav nav-treeview ${
                            menuState["Integration"] ? "show" : ""
                          }`}
                        >
                          <li className="nav-item">
                            <Link to="/integration" className="nav-link">
                              <i className="far fa-circle nav-icon" />
                              <p>Integration</p>
                            </Link>
                          </li>
                        </ul>
                      </li>
                      <li className="nav-item">
                        <div
                          className="nav-link"
                          onClick={createToggleMenuHandler(
                            menuState,
                            setMenuState,
                            "Tiers"
                          )}
                        >
                          <i className="nav-icon fas fa-solid fa-building"></i>
                          <p>
                            Clients et fournisseurs
                            <i
                              className={`right fas fa-angle-${menuState["Tiers"] ? "down" : "left"
                                }`}
                            />
                          </p>
                        </div>

                        <ul
                          className={`nav nav-treeview ${menuState["Tiers"] ? "show" : ""
                            }`}
                        >
                          <li className="nav-item">
                            <Link to="/tiers" className="nav-link">
                              <i className="far fa-circle nav-icon" />
                              <p>Tiers</p>
                            </Link>
                          </li>
                          <li className="nav-item">
                            <Link to="/zone" className="nav-link">
                              <i className="far fa-circle nav-icon" />
                              <p>Zone</p>
                            </Link>
                          </li>
                        </ul>
                      </li>
                      <li className="nav-item">
                        <Link to="/Personnels" className="nav-link">
                          <i className="nav-icon fas fa-solid fa-user"></i>{" "}
                          <p>Mes utilisateurs</p>
                        </Link>

                        <ul className="nav nav-treeview">

                          {/* <li className="nav-item">
                            <Link
                              to="/configuration-colis-livraison"
                              className="nav-link"
                            >
                              <i className="far fa-circle nav-icon" />
                              <p>Configuration livraison</p>
                            </Link>
                          </li> */}
                          {/* <li className="nav-item">
                            <Link
                              to="/configuration-emails-societe"
                              className="nav-link"
                            >
                              <i className="far fa-circle nav-icon" />
                              <p>Configuration Emails</p>
                            </Link>
                          </li> */}
                        </ul>
                      </li>
                      <li className="nav-item">
                        <div
                          className="nav-link"
                          onClick={createToggleMenuHandler(
                            menuState,
                            setMenuState,
                            "Product"
                          )}
                        >
                          <i className="nav-icon fab fa-brands fa-product-hunt"></i>

                          <p>
                            Mes produits
                            <i
                              className={`right fas fa-angle-${menuState["Product"] ? "down" : "left"
                                }`}
                            />
                          </p>
                        </div>
                        <ul
                          className={`nav nav-treeview ${menuState["Product"] ? "show" : ""
                            }`}
                        >
                            {/* {showElement.includes("ADMIN") && (
                            <li className="nav-item">
                              <Link to="/KPIProduits" className="nav-link">
                                <i className="far fa-circle nav-icon" />
                                <p>KPI Produits</p>
                              </Link>
                            </li>
                          )} */}
                          {(showElement.includes("PURCHASING_MANAGER") ||
                            showElement.includes("ADMIN") ||
                            showElement.includes("WAREHOUSE_MANAGER")) && (
                              <li className="nav-item">
                                <Link to="/products" className="nav-link">
                                  <i className="far fa-circle nav-icon" />
                                  <p>Produits</p>
                                </Link>
                              </li>
                            )}
                      
                          {/* {(showElement.includes("PURCHASING_MANAGER") ||
                            showElement.includes("ADMIN") ||
                            showElement.includes("WAREHOUSE_MANAGER")) && (
                              <li className="nav-item">
                                <Link to="/Lots" className="nav-link">
                                  <i className="far fa-circle nav-icon" />
                                  <p>Lots</p>
                                </Link>
                              </li>
                            )} */}

                          {(showElement.includes("PURCHASING_MANAGER") ||
                            showElement.includes("ADMIN") ||
                            showElement.includes("WAREHOUSE_MANAGER")) && (
                              <li className="nav-item">
                                <Link to="/specificities" className="nav-link">
                                  <i className="far fa-circle nav-icon" />
                                  <p>Spécificités</p>
                                </Link>
                              </li>
                            )}

                          {(showElement.includes("PURCHASING_MANAGER") ||
                            showElement.includes("ADMIN")) && (
                              <li className="nav-item">
                                <Link to="/Brands" className="nav-link">
                                  <i className="far fa-circle nav-icon" />
                                  <p>Les marques</p>
                                </Link>
                              </li>
                            )}
                          {(showElement.includes("PURCHASING_MANAGER") ||
                            showElement.includes("ADMIN")) && (
                              <li className="nav-item">
                                <Link to="/families" className="nav-link">
                                  <i className="far fa-circle nav-icon" />
                                  <p>Les familles</p>
                                </Link>
                              </li>
                            )}
                          {(showElement.includes("PURCHASING_MANAGER") ||
                            showElement.includes("ADMIN")) && (
                              <li className="nav-item">
                                <Link to="/subFamilies" className="nav-link">
                                  <i className="far fa-circle nav-icon" />
                                  <p>Les sous familles</p>
                                </Link>
                              </li>
                            )}

                          {(showElement.includes("PURCHASING_MANAGER") ||
                            showElement.includes("ADMIN")) && (
                              <li className="nav-item">
                                <Link to="/categories" className="nav-link">
                                  <i className="far fa-circle nav-icon" />
                                  <p>Les catégories</p>
                                </Link>
                              </li>
                            )}
                        </ul>
                      </li>
                      <li className="nav-item">
                        <div
                          className="nav-link"
                          onClick={createToggleMenuHandler(
                            menuState,
                            setMenuState,
                            "Depot"
                          )}
                        >
                          <i className="nav-icon fas fa-solid fa-warehouse"></i>
                          <p>
                            Gestion de stock
                            <i
                              className={`right fas fa-angle-${menuState["Depot"] ? "down" : "left"
                                }`}
                            />
                          </p>
                        </div>
                        <ul
                          className={`nav nav-treeview ${menuState["Depot"] ? "show" : ""
                            }`}
                        >
                          {(showElement.includes("PURCHASING_MANAGER") ||
                            showElement.includes("WAREHOUSE_MANAGER") ||
                            showElement.includes("ADMIN")) && (
                              <li className="nav-item">
                                <Link to="/warehouses" className="nav-link">
                                  <i className="far fa-circle nav-icon" />
                                  <p>Dépôts</p>
                                </Link>
                              </li>
                            )}
                     
                          {(showElement.includes("PURCHASING_MANAGER") ||
                            showElement.includes("WAREHOUSE_MANAGER") ||
                            showElement.includes("ADMIN")) && (
                              <li className="nav-item">
                                <Link to="/EtatStocks" className="nav-link">
                                  <i className="far fa-circle nav-icon" />
                                  <p>Etat des stocks</p>
                                </Link>
                              </li>
                            )}
                              {(showElement.includes("PURCHASING_MANAGER") ||
                            showElement.includes("WAREHOUSE_MANAGER") ||
                            showElement.includes("ADMIN")) && (
                              <li className="nav-item">
                                <Link to="/searchProductsWarehouse" className="nav-link">
                                  <i className="far fa-circle nav-icon" />
                                  <p>Produits</p>
                                </Link>
                              </li>
                            )}
                          {/* {(showElement.includes("PURCHASING_MANAGER") ||
                            showElement.includes("WAREHOUSE_MANAGER") ||
                            showElement.includes("ADMIN")) && (
                              <li className="nav-item">
                                <Link to="/scannerProduit" className="nav-link">
                                  <i className="far fa-circle nav-icon" />
                                  <p>Scanner</p>
                                </Link>
                              </li>
                            )} */}

                          <li className="nav-item">
                            <div
                              className="nav-link"
                              onClick={createToggleMenuHandler(
                                menuState,
                                setMenuState,
                                "INVENTAIRE"
                              )}
                            >
                              <i className="far fa-circle nav-icon"></i>
                              <p>
                                Comptage du stock
                                <i
                                  className={`right fas fa-angle-${menuState["INVENTAIRE"] ? "down" : "left"
                                    }`}
                                ></i>
                              </p>
                            </div>
                            <ul
                              className={`nav nav-treeview ${menuState["INVENTAIRE"] ? "show" : ""
                                }`}
                            >
                              {(showElement.includes("PURCHASING_MANAGER") ||
                                showElement.includes("ADMIN")) && (
                                  <li className="nav-item">
                                    <Link className="nav-link" to="/inventaires">
                                      {/* <i className="far fa-circle nav-icon" /> */}
                                      <p>Inventaire</p>
                                    </Link>
                                  </li>
                                )}
                            </ul>
                          </li>

                          {(showElement.includes("PURCHASING_MANAGER") ||
                            showElement.includes("WAREHOUSE_MANAGER") ||
                            showElement.includes("ADMIN")) && (
                              <li className="nav-item">
                                <Link to="/bonreception" className="nav-link">
                                  <i className="far fa-circle nav-icon" />
                                  <p>Bon de réception</p>
                                </Link>
                              </li>
                            )}

                          {(showElement.includes("PURCHASING_MANAGER") ||
                            showElement.includes("WAREHOUSE_MANAGER") ||
                            showElement.includes("ADMIN")) && (
                              <li className="nav-item">
                                <Link to="/bonsortie" className="nav-link">
                                  <i className="far fa-circle nav-icon" />
                                  <p>Bon de Sortie</p>
                                </Link>
                              </li>
                            )}
                          {(showElement.includes("PURCHASING_MANAGER") ||
                            showElement.includes("WAREHOUSE_MANAGER") ||
                            showElement.includes("ADMIN")) && (
                              <li className="nav-item">
                                <Link to="/bonretour" className="nav-link">
                                  <i className="far fa-circle nav-icon" />
                                  <p>Bon de Retour</p>
                                </Link>
                              </li>
                            )}

                          {(showElement.includes("WAREHOUSE_MANAGER") ||
                            showElement.includes("ADMIN")) && (
                              <>
                                <li className="nav-item">
                                  <Link
                                    className="nav-link"
                                    to="/transfertsByWarehouseManager"
                                  >
                                    <i className="far fa-circle nav-icon" />
                                    <p>Les transferts</p>
                                  </Link>
                                </li>

                                {/* <li className="nav-item">
                                  <Link
                                    className="nav-link"
                                    to="/warehouseTransfert"
                                  >
                                    <i className="far fa-circle nav-icon" />
                                    <p>Demander transfert</p>
                                  </Link>
                                </li> */}
                              </>
                            )}

                          {showElement.includes("ADMIN") && (
                            <li className="nav-item">
                              <Link className="nav-link" to="/confirmTransfert">
                                <i className="far fa-circle nav-icon" />
                                <p>Confirmer transfert</p>
                              </Link>
                            </li>
                          )}
                          {/* ||
                            showElement.includes("ADMIN") */}
                          {showElement.includes("WAREHOUSE_MANAGER") && (
                            <li className="nav-item">
                              <Link className="nav-link" to="/receiveTransfert">
                                <i className="far fa-circle nav-icon" />
                                <p>Gestion des transferts</p>
                              </Link>
                            </li>
                          )}
                        </ul>
                      </li>
                      <li className="nav-item">
                        <div
                          className="nav-link"
                          onClick={createToggleMenuHandler(
                            menuState,
                            setMenuState,
                            "Purchase"
                          )}
                        >
                          <i
                            className="nav-icon fas fa-cart-arrow-down"
                          // style={{ fontSize: "22px" }}
                          ></i>
                          <p>
                            Achats
                            <i
                              className={`right fas fa-angle-${menuState["Purchase"] ? "down" : "left"
                                }`}
                            />
                          </p>
                        </div>

                        <ul
                          className={`nav nav-treeview ${menuState["Purchase"] ? "show" : ""
                            }`}
                        >
                          {(showElement.includes("PURCHASING_MANAGER") ||
                            showElement.includes("ADMIN")) && (
                              <li className="nav-item">
                                <Link className="nav-link" to="/kpiachat">
                                  <i className="far fa-circle nav-icon " />
                                  <p>KPI Achat</p>
                                </Link>
                              </li>
                            )}
                          {(showElement.includes("PURCHASING_MANAGER") ||
                            showElement.includes("ADMIN")) && (
                              <li className="nav-item">
                                <Link className="nav-link" to="/taxes">
                                  <i className="far fa-circle nav-icon " />
                                  <p>Taxes / Charges</p>
                                </Link>
                              </li>
                            )}
                          {(showElement.includes("PURCHASING_MANAGER") ||
                            showElement.includes("ADMIN") ||
                            showElement.includes("DEMANDEUR")) && (
                              <li className="nav-item">
                                <Link className="nav-link" to="/demandesAchat">
                                  <i className="far fa-circle nav-icon" />
                                  <p>Demandes d'Achat</p>
                                </Link>
                              </li>
                            )}

                          {(showElement.includes("PURCHASING_MANAGER") ||
                            showElement.includes("ADMIN")) && (
                              <li className="nav-item">
                                <Link className="nav-link" to="/allQuotation">
                                  <i className="far fa-circle nav-icon" />
                                  <p>les devis</p>
                                </Link>
                              </li>
                            )}

                          {(showElement.includes("PURCHASING_MANAGER") ||
                            showElement.includes("ADMIN")) && (
                              <li className="nav-item">
                                <Link className="nav-link" to="/bonsDeCommande">
                                  <i className="far fa-circle nav-icon" />
                                  <p> Les bons de commande </p>
                                </Link>
                              </li>
                            )}

                          {(showElement.includes("PURCHASING_MANAGER") ||
                            showElement.includes("ADMIN")) && (
                              <li className="nav-item">
                                <Link className="nav-link" to="/factures">
                                  <i className="far fa-circle nav-icon" />
                                  <p> Les factures </p>
                                </Link>
                              </li>
                            )}

                          {/* {(showElement.includes("PURCHASING_MANAGER") ||
                            showElement.includes("ADMIN")) && (
                            <li className="nav-item">
                              <Link
                                className="nav-link"
                                to="/allPurchaseOrders"
                              >
                                <i className="far fa-circle nav-icon" />
                                <p> Les achats </p>
                              </Link>
                            </li>
                          )} */}

                          {(showElement.includes("PURCHASING_MANAGER") ||
                            showElement.includes("ADMIN") ||
                            showElement.includes("WAREHOUSE_MANAGER")) && (
                              <li className="nav-item">
                                <Link
                                  className="nav-link"
                                  to="/receivePurchaseOrder"
                                >
                                  <i className="far fa-circle nav-icon" />
                                  <p>Recevoir une commande </p>
                                </Link>
                              </li>
                            )}

                          {/* {showElement.includes("ADMIN") && (
                            <li className="nav-item">
                              <Link className="nav-link" to="/prixAchat">
                                <i className="far fa-circle nav-icon" />
                                <p>Prix</p>
                              </Link>
                            </li>
                          )} */}

                          {/* {showElement.includes("PURCHASING_MANAGER") && (
                            <li className="nav-item">
                              <Link className="nav-link" to="/predection">
                                <i className="far fa-circle nav-icon" />
                                <p>Préversion </p>
                              </Link>
                            </li>
                          )} */}

                          {/* {showElement.includes("ADMIN") && (
                            <>
                              <li className="nav-item">
                                <Link
                                  className="nav-link"
                                  to="/listSocieteAchat"
                                >
                                  <i className="far fa-circle nav-icon" />
                                  <p>Payement </p>
                                </Link>
                              </li>

                              <li className="nav-item">
                                <Link
                                  className="nav-link"
                                  to="/allBanqueAccounts"
                                >
                                  <i className="far fa-circle nav-icon" />
                                  <p>Comptes bancaires </p>
                                </Link>
                              </li>

                              <li className="nav-item">
                                <Link className="nav-link" to="/predection">
                                  <i className="far fa-circle nav-icon" />
                                  <p>Préversion </p>
                                </Link>
                              </li>
                            </>
                          )} */}
                        </ul>
                      </li>{" "}
                      <li className="nav-item">
                        <div
                          className="nav-link"
                          onClick={createToggleMenuHandler(
                            menuState,
                            setMenuState,
                            "Sale"
                          )}
                        >
                          <i
                            className="nav-icon fas fa-shopping-cart"
                          // style={{ fontSize: "22px" }}
                          ></i>

                          <p>
                            Ventes
                            <i
                              className={`right fas fa-angle-${menuState["Sale"] ? "down" : "left"
                                }`}
                            />
                          </p>
                        </div>
                        <ul
                          className={`nav nav-treeview ${menuState["Sale"] ? "show" : ""
                            }`}
                        >
                              {(showElement.includes("PURCHASING_MANAGER") ||
                                showElement.includes("ADMIN")) && (
                                  <li className="nav-item">
                                    <Link className="nav-link" to="/kpisale">
                                      {/* <i className="far fa-circle nav-icon" /> */}
                                      <p>KPI Vente</p>
                                    </Link>
                                  </li>
                                )}
                              {(showElement.includes("PURCHASING_MANAGER") ||
                                showElement.includes("ADMIN")) && (
                                  <li className="nav-item">
                                    <Link className="nav-link" to="/productSell">
                                      {/* <i className="far fa-circle nav-icon" /> */}
                                      <p>Prix de vente</p>
                                    </Link>
                                  </li>
                                )}
                                   <li className="nav-item">
                                  <Link className="nav-link" to="/ListeOffres">
                                    <p>Offres</p>
                                  </Link>
                                </li>
                              {(showElement.includes("PURCHASING_MANAGER") ||
                                showElement.includes("ADMIN")) && (
                                  <li className="nav-item">
                                    <Link className="nav-link" to="/allDevis">
                                      {/* <i className="far fa-circle nav-icon" /> */}
                                      <p>les devis</p>
                                    </Link>
                                  </li>
                                )}

                              {(showElement.includes("PURCHASING_MANAGER") ||
                                showElement.includes("ADMIN")) && (
                                  <li className="nav-item">
                                    <Link
                                      className="nav-link"
                                      to="/bonCommandeVente"
                                    >
                                      {/* <i className="far fa-circle nav-icon" /> */}
                                      <p> Les bons de commande </p>
                                    </Link>
                                  </li>
                                )}
                              {/* {showElement.includes("ADMIN") && (
                                <li className="nav-item">
                                  <Link
                                    className="nav-link"
                                    to="/ModifierBonCommandeVente"
                                  >
                                    <p>Modifier les bons de commande</p>
                                  </Link>
                                </li>
                              )} */}
                              {(showElement.includes("PURCHASING_MANAGER") ||
                                showElement.includes("ADMIN")) && (
                                  <li className="nav-item">
                                    <Link
                                      className="nav-link"
                                      to="/allFactureSell"
                                    >
                                      {/* <i className="far fa-circle nav-icon" /> */}
                                      <p> Les factures </p>
                                    </Link>
                                  </li>
                                )}

<li className="nav-item">
  <Link className="nav-link" to="/suiviLivraisons">
    <p>Suivi des livraisons</p>
  </Link>
</li>
                              {(showElement.includes("PURCHASING_MANAGER") ||
                                showElement.includes("ADMIN") ||
                                showElement.includes("WAREHOUSE_MANAGER")) && (
                                  <li className="nav-item">
                                    <Link
                                      className="nav-link"
                                      to="/sendPurchaseOrder"
                                    >
                                      {/* <i className="far fa-circle nav-icon" /> */}
                                      <p>Sortir une commande </p>
                                    </Link>
                                  </li>
                                )}
                              {(showElement.includes("PURCHASING_MANAGER") ||
                                showElement.includes("ADMIN") ||
                                showElement.includes("WAREHOUSE_MANAGER")) && (
                                  <li className="nav-item">
                                    <Link
                                      className="nav-link"
                                      to="/retourSalesOrder"
                                    >
                                      {/* <i className="far fa-circle nav-icon" /> */}
                                      <p>Retour de commande </p>
                                    </Link>
                                  </li>
                                )}
                              {/* {(showElement.includes("PURCHASING_MANAGER") ||
                                showElement.includes("ADMIN")) && (
                                  <li className="nav-item">
                                    <Link
                                      className="nav-link"
                                      to="/colis-livraison"
                                    >
                                      <p>Colis</p>
                                    </Link>
                                  </li>
                                )} */}

                    
                        </ul>
                      </li>{" "}
                   
                      {showElement.includes("ADMIN") && (
                        <li className="nav-item">
                          <div
                            className="nav-link"
                            onClick={createToggleMenuHandler(
                              menuState,
                              setMenuState,
                              "Finance"
                            )}
                          >
                            <i className="fas fa-money-bill-wave"></i>{" "}
                            <p>
                              Comptes et paiements
                              <i
                                className={`right fas fa-angle-${menuState["Finance"] ? "down" : "left"
                                  }`}
                              />
                            </p>
                          </div>
                          <ul
                            className={`nav nav-treeview ${menuState["Finance"] ? "show" : ""
                              }`}
                          >
                            {/* <li className="nav-item">
                              <Link className="nav-link" to="/kpipayements">
                                <i className="far fa-circle nav-icon" />
                                <p>KPI Payements </p>
                              </Link>
                            </li> */}
                            <li className="nav-item">
                              <div
                                className="nav-link"
                                onClick={createToggleMenuHandler(
                                  menuState,
                                  setMenuState,
                                  "Accounts"
                                )}
                              >
                                <i className="far fa-circle nav-icon"></i>
                                <p>
                                  Les Comptes
                                  <i
                                    className={`right fas fa-angle-${menuState["Accounts"] ? "down" : "left"
                                      }`}
                                  ></i>
                                </p>
                              </div>
                              <ul
                                className={`nav nav-treeview ${menuState["Accounts"] ? "show" : ""
                                  }`}
                              >
                                <li className="nav-item">
                                  <Link
                                    to="/allBanqueAccounts"
                                    className="nav-link"
                                  >
                                    <p>Détails des comptes</p>
                                  </Link>
                                </li>
                                <li className="nav-item">
                                  <Link
                                    to="/transfertsEntreCompte"
                                    className="nav-link"
                                  >
                                    <p>Transfert </p>
                                  </Link>
                                </li>
                                <li className="nav-item">
                                  <Link
                                    to="/listBordereau"
                                    className="nav-link"
                                  >
                                    <p>Bordereau</p>
                                  </Link>
                                </li>
                                <li className="nav-item">
                                  <Link
                                    to="/allAgendaPayement"
                                    className="nav-link"
                                  >
                                    <p>Agenda des payements </p>
                                  </Link>
                                </li>
                                {/* <li className="nav-item">
                                  <div
                                    className="nav-link"
                                    onClick={createToggleMenuHandler(
                                      menuState,
                                      setMenuState,
                                      "wallets"
                                    )}
                                  >
                                    <i class="fas fa-wallet nav-icon"></i>
                                    <p>
                                      Les Wallets
                                      <i
                                        className={`right fas fa-angle-${menuState["wallets"] ? "down" : "left"
                                          }`}
                                      ></i>
                                    </p>
                                  </div>
                                  <ul
                                    className={`nav nav-treeview ${menuState["wallets"] ? "show" : ""
                                      }`}
                                  >
                                    <li className="nav-item">
                                      <Link
                                        to="/walletClient"
                                        className="nav-link"
                                      >
                                        <p>Wallets Clients </p>
                                      </Link>
                                    </li>
                                    <li className="nav-item">
                                      <Link
                                        to="/walletFournisseur"
                                        className="nav-link"
                                      >
                                        <p>Wallets Fournisseurs </p>
                                      </Link>
                                    </li>
                                  </ul>
                                </li> */}
                              </ul>
                            </li>

                            <li className="nav-item">
                              <div
                                className="nav-link"
                                onClick={createToggleMenuHandler(
                                  menuState,
                                  setMenuState,
                                  "FinancePurchase"
                                )}
                              >
                                <i className="far fa-circle nav-icon"></i>
                                <p>
                                  Achats
                                  <i
                                    className={`right fas fa-angle-${menuState["FinancePurchase"]
                                      ? "down"
                                      : "left"
                                      }`}
                                  ></i>
                                </p>
                              </div>
                              <ul
                                className={`nav nav-treeview ${menuState["FinancePurchase"] ? "show" : ""
                                  }`}
                              >
                                <li className="nav-item">
                                  <Link
                                    to="/listSocieteAchat"
                                    className="nav-link"
                                  >
                                    <p>Payement</p>
                                  </Link>
                                </li>
                                {/* <li className="nav-item">
                                  <Link
                                    to="/listFournisseurSolde"
                                    className="nav-link"
                                  >
                                    <p>Solde</p>
                                  </Link>
                                </li> */}
                                     <li className="nav-item">
                                  <Link
                                    to="/ficheFounisseur"
                                    className="nav-link"
                                  >
                                    <p>Fiche Fournisseur</p>
                                  </Link>
                                </li>
                              </ul>
                            </li>

                            <li className="nav-item">
                              <div
                                className="nav-link"
                                onClick={createToggleMenuHandler(
                                  menuState,
                                  setMenuState,
                                  "FinanceSales"
                                )}
                              >
                                <i className="far fa-circle nav-icon"></i>
                                <p>
                                  Ventes
                                  <i
                                    className={`right fas fa-angle-${menuState["FinanceSales"]
                                      ? "down"
                                      : "left"
                                      }`}
                                  ></i>
                                </p>
                              </div>
                              <ul
                                className={`nav nav-treeview ${menuState["FinanceSales"] ? "show" : ""
                                  }`}
                              >
                                <li className="nav-item">
                                  <Link
                                    to="/listSocieteVente"
                                    className="nav-link"
                                  >
                                    <p>Payement</p>
                                  </Link>
                                </li>
                                {/* <li className="nav-item">
                                  <Link
                                    to="/PayementGroupe"
                                    className="nav-link"
                                  >
                                    <p>Payement par groupe</p>
                                  </Link>
                                </li> */}
                                {/* <li className="nav-item">
                                  <Link
                                    to="/listClientSolde"
                                    className="nav-link"
                                  >
                                    <p>Solde</p>
                                  </Link>
                                </li> */}
                                <li className="nav-item">
                                  <Link to="/ficheClient" className="nav-link">
                                    <p>Fiche Client</p>
                                  </Link>
                                </li>
                              </ul>
                            </li>

                          

                            <li className="nav-item">
                              <Link className="nav-link" to="/chargesEtat">
                                <i className="far fa-circle nav-icon" />
                                <p>Charges </p>
                              </Link>
                            </li>
                          
                          </ul>
                        </li>
                      )}
                      {/* Ressources humaines + Production (désactivés)
                      <li className="nav-item">
                        <div
                          className="nav-link"
                          onClick={createToggleMenuHandler(
                            menuState,
                            setMenuState,
                            "Rh"
                          )}
                        >
                          <i className="nav-icon fas fa-users"></i>
                          <p>
                            Ressources humaines
                            <i
                              className={`right fas fa-angle-${menuState["Rh"] ? "down" : "left"
                                }`}
                            />
                          </p>
                        </div>

                        <ul
                          className={`nav nav-treeview ${menuState["Rh"] ? "showRh" : ""
                            }`}
                        >
                          {(showElement.includes("PURCHASING_MANAGER") ||
                            showElement.includes("ADMIN")) && (
                              <>
                                {/ * <li className="nav-item">
                                  <Link className="nav-link" to="/dashboardRH">
                                    <i className="far fa-circle nav-icon" />
                                    <p>Statistiques</p>
                                  </Link>
                                </li> * /}
                                <li className="nav-item">
                                  <Link to="/employeeList" className="nav-link">
                                    <i className="far fa-circle nav-icon"></i>
                                    <p>Personnels</p>
                                  </Link>
                                </li>
                                <li className="nav-item">
                                  <Link to="/contractList" className="nav-link">
                                    <i className="far fa-circle nav-icon"></i>
                                    <p>Contrats</p>
                                  </Link>
                                </li>
                                <li className="nav-item">
                                  <Link to="/departmentList" className="nav-link">
                                    <i className="far fa-circle nav-icon"></i>
                                    <p>Départements</p>
                                  </Link>
                                </li>
                                <li className="nav-item">
                                  <Link to="/crewList" className="nav-link">
                                    <i className="far fa-circle nav-icon"></i>
                                    <p>Equipes</p>
                                  </Link>
                                </li>
                                <li className="nav-item">
                                  <Link to="/ordreDeMission" className="nav-link">
                                    <i className="far fa-circle nav-icon"></i>
                                    <p> Ordres de mission</p>
                                  </Link>
                                </li>
                                <li className="nav-item">
                                  <Link
                                    to="/mission_interne"
                                    className="nav-link"
                                  >
                                    <i className="far fa-circle nav-icon"></i>
                                    <p>Contrats de partage</p>
                                  </Link>
                                </li>
                                <li className="nav-item">
                                  <Link
                                    to="/Attendance_list"
                                    className="nav-link"
                                  >
                                    <i className="far fa-circle nav-icon"></i>
                                    <p>Présences</p>
                                  </Link>
                                </li>
                                <li className="nav-item">
                                  <Link to="/LeaveRequests" className="nav-link">
                                    <i className="far fa-circle nav-icon"></i>{" "}
                                    <p>Demandes de Congé</p>
                                  </Link>
                                </li>
                                <li className="nav-item">
                                  <div
                                    className="nav-link"
                                    onClick={createToggleMenuHandler(
                                      menuState,
                                      setMenuState,
                                      "FicheDePaies"
                                    )}
                                  >
                                    <i className="far fa-circle nav-icon"></i>
                                    <p>
                                      Les Fiches de paies
                                      <i
                                        className={`right fas fa-angle-${menuState["FicheDePaies"]
                                          ? "down"
                                          : "left"
                                          }`}
                                      ></i>
                                    </p>
                                  </div>
                                  <ul
                                    className={`nav nav-treeview ${menuState["FicheDePaies"] ? "show" : ""
                                      }`}
                                  >
                                    <li className="nav-item">
                                      <Link
                                        to="/ficheDePaie"
                                        className="nav-link"
                                      >
                                        <p>Par présence </p>
                                      </Link>
                                    </li>
                                    <li className="nav-item">
                                      <Link
                                        to="/fichedepaieparsalaire"
                                        className="nav-link"
                                      >
                                        <p>Sur salaire </p>
                                      </Link>
                                    </li>
                                  </ul>
                                </li>
                                <li className="nav-item">
                                  <div
                                    className="nav-link"
                                    onClick={createToggleMenuHandler(
                                      menuState,
                                      setMenuState,
                                      "Settings"
                                    )}
                                  >
                                    <i className="far fa-circle nav-icon"></i>
                                    <p>
                                      Paramétrage global
                                      <i
                                        className={`right fas fa-angle-${menuState["Settings"] ? "down" : "left"
                                          }`}
                                      ></i>
                                    </p>
                                  </div>
                                  <ul
                                    className={`nav nav-treeview ${menuState["Settings"] ? "show" : ""
                                      }`}
                                  >
                                    <li className="nav-item">
                                      <Link to="/postList" className="nav-link">
                                        {/ * <i className="fa-solid fa-briefcase nav-icon"></i> * /}
                                        <p>Postes</p>
                                      </Link>
                                    </li>
                                    <li className="nav-item">
                                      <Link
                                        to="/contracttype"
                                        className="nav-link"
                                      >
                                        {/ * <i className="fa-solid fa-file-contract nav-icon"></i> * /}
                                        <p>Types de contrat</p>
                                      </Link>
                                    </li>
                                    <li className="nav-item">
                                      <Link to="/primelist" className="nav-link">
                                        {/ * <i className="fa-solid fa-money-bill nav-icon"></i> * /}
                                        <p>Primes</p>
                                      </Link>
                                    </li>
                                    <li className="nav-item">
                                      <Link
                                        to="/LeaveTypeList"
                                        className="nav-link"
                                      >
                                        {/ * <i className="nav-icon fa-solid fa-note-sticky"></i> * /}
                                        <p>Types de congé</p>
                                      </Link>
                                    </li>
                                    <li className="nav-item">
                                      <Link
                                        to="/paimentSettigs"
                                        className="nav-link"
                                      >
                                        {/ * <i className="nav-icon fa-solid fa-note-sticky"></i> * /}
                                        <p>Paramétrage de paiement</p>
                                      </Link>
                                    </li>
                                  </ul>
                                </li>
                              </>
                            )}
                        </ul>
                      </li>
                      {showElement.includes("ADMIN") && (
                        <li className="nav-item">
                          <div
                            className="nav-link"
                            onClick={createToggleMenuHandler(
                              menuState,
                              setMenuState,
                              "Production"
                            )}
                          >
                            <i className=" nav-icon fa-solid fa-industry"></i>
                            <p>
                              Production
                              <i
                                className={`right fas fa-angle-${menuState["Production"] ? "down" : "left"
                                  }`}
                              />
                            </p>
                          </div>

                          <ul
                            className={`nav nav-treeview ${menuState["Production"] ? "show" : ""
                              }`}
                          >
                            <li className="nav-item">
                              <div
                                className="nav-link"
                                onClick={createToggleMenuHandler(
                                  menuState,
                                  setMenuState,
                                  "Ressources"
                                )}
                              >
                                <i className="far fa-circle nav-icon" />
                                <p>
                                  Resources
                                  <i
                                    className={`right fas fa-angle-${menuState["Ressources"] ? "down" : "left"
                                      }`}
                                  />
                                </p>
                              </div>
                              <ul
                                className={`nav nav-treeview ${menuState["Ressources"] ? "show" : ""
                                  }`}
                              >
                                <li className="nav-item">
                                  <Link to="/uom" className="nav-link">
                                    <p>Unité de mesure</p>
                                  </Link>
                                </li>
                                <li className="nav-item">
                                  <Link to="/workstations" className="nav-link">
                                    <p>Station de travail</p>
                                  </Link>
                                </li>
                                <li className="nav-item">
                                  <Link to="/operations" className="nav-link">
                                    <p>Opération</p>
                                  </Link>
                                </li>
                                <li className="nav-item">
                                  <Link to="/bom" className="nav-link">
                                    <p>BOM</p>
                                  </Link>
                                </li>
                              </ul>
                            </li>

                            <li className="nav-item">
                              <div
                                className="nav-link"
                                onClick={createToggleMenuHandler(
                                  menuState,
                                  setMenuState,
                                  "SubProduction"
                                )}
                              >
                                <i className="far fa-circle nav-icon" />
                                <p>
                                  Production
                                  <i
                                    className={`right fas fa-angle-${menuState["SubProduction"]
                                      ? "down"
                                      : "left"
                                      }`}
                                  />
                                </p>
                              </div>
                              <ul
                                className={`nav nav-treeview ${menuState["SubProduction"] ? "show" : ""
                                  }`}
                              >
                                <li className="nav-item">
                                  <Link
                                    to="/production-orders"
                                    className="nav-link"
                                  >
                                    <p>Ordre de Production</p>
                                  </Link>
                                </li>

                                <li className="nav-item">
                                  <Link
                                    to="/kpiProductionOrder"
                                    className="nav-link"
                                  >
                                    <p>KPI Production</p>
                                  </Link>
                                </li>
                              </ul>
                            </li>
                          </ul>
                        </li>
                      )}
                      */}
                    </>
                  )}
                  {showElement.includes("USER_B2B") && (
                    <>
                      <li className="nav-item">
                        <div
                          className="nav-link"
                          onClick={createToggleMenuHandler(
                            menuState,
                            setMenuState,
                            "Product"
                          )}
                        >
                          <i className="nav-icon fab fa-brands fa-product-hunt"></i>

                          <p>
                            Mes produits
                            <i
                              className={`right fas fa-angle-${menuState["Product"] ? "down" : "left"
                                }`}
                            />
                          </p>
                        </div>
                        <ul
                          className={`nav nav-treeview ${menuState["Product"] ? "show" : ""
                            }`}
                        >
                          <li className="nav-item">
                            <Link to="/products" className="nav-link">
                              <i className="far fa-circle nav-icon" />
                              <p>Produits</p>
                            </Link>
                          </li>
                        </ul>
                      </li>
                      <li className="nav-item">
                        <div
                          className="nav-link"
                          onClick={createToggleMenuHandler(
                            menuState,
                            setMenuState,
                            "Depot"
                          )}
                        >
                          <i className="nav-icon fas fa-solid fa-warehouse"></i>
                          <p>
                            Gestion de stock
                            <i
                              className={`right fas fa-angle-${menuState["Depot"] ? "down" : "left"
                                }`}
                            />
                          </p>
                        </div>
                        <ul
                          className={`nav nav-treeview ${menuState["Depot"] ? "show" : ""
                            }`}
                        >
                          <li className="nav-item">
                            <Link to="/warehouses" className="nav-link">
                              <i className="far fa-circle nav-icon" />
                              <p>Dépôts</p>
                            </Link>
                          </li>
                          <li className="nav-item">
                            <Link to="/rfidTransfert" className="nav-link">
                              <i className="far fa-circle nav-icon" />
                              <p>RFID</p>
                            </Link>
                          </li>
                        </ul>
                      </li>
                      <li className="nav-item">
                        <div
                          className="nav-link"
                          onClick={createToggleMenuHandler(
                            menuState,
                            setMenuState,
                            "Sale"
                          )}
                        >
                          <i
                            className="nav-icon fas fa-shopping-cart"
                          // style={{ fontSize: "22px" }}
                          ></i>

                          <p>
                            Ventes
                            <i
                              className={`right fas fa-angle-${menuState["Sale"] ? "down" : "left"
                                }`}
                            />
                          </p>
                        </div>
                        <ul
                          className={`nav nav-treeview ${menuState["Sale"] ? "show" : ""
                            }`}
                        >
                              <li className="nav-item">
                                <Link className="nav-link" to="/allDevis">
                                  {/* <i className="far fa-circle nav-icon" /> */}
                                  <p>les devis</p>
                                </Link>
                              </li>
                        </ul>
                      </li>{" "}
                    </>
                  )}

                  {showElement.includes("WAREHOUSE_MANAGER") &&
                    !showElement.includes("COMMERCIAL") &&
                    !showElement.includes("DIRECTEUR_MAGASIN")&&!showElement.includes("CHEF_CHAINE") && (
                      <>
                        <li className="nav-item">
                          <div
                            className="nav-link"
                            onClick={createToggleMenuHandler(
                              menuState,
                              setMenuState,
                              "Depot"
                            )}
                          >
                            <i className="nav-icon fas fa-solid fa-warehouse"></i>
                            <p>
                              Gestion de stock
                              <i
                                className={`right fas fa-angle-${menuState["Depot"] ? "down" : "left"
                                  }`}
                              />
                            </p>
                          </div>
                          <ul
                            className={`nav nav-treeview ${menuState["Depot"] ? "show" : ""
                              }`}
                          >
                            <li className="nav-item">
                              <Link to="/warehouses" className="nav-link">
                                <i className="far fa-circle nav-icon" />
                                <p>Dépôts</p>
                              </Link>
                            </li>
                            <li className="nav-item">
                              <Link to="/rfidTransfert" className="nav-link">
                                <i className="far fa-circle nav-icon" />
                                <p>RFID</p>
                              </Link>
                            </li>
                            <li className="nav-item">
                              <Link to="/bonreception" className="nav-link">
                                <i className="far fa-circle nav-icon" />
                                <p>Bon de réception</p>
                              </Link>
                            </li>

                            <li className="nav-item">
                              <Link to="/bonsortie" className="nav-link">
                                <i className="far fa-circle nav-icon" />
                                <p>Bon de Sortie</p>
                              </Link>
                            </li>

                            <li className="nav-item">
                              <Link to="/bonretour" className="nav-link">
                                <i className="far fa-circle nav-icon" />
                                <p>Bon de Retour</p>
                              </Link>
                            </li>

                            <>
                              <li className="nav-item">
                                <Link
                                  className="nav-link"
                                  to="/transfertsByWarehouseManager"
                                >
                                  <i className="far fa-circle nav-icon" />
                                  <p>Les transferts</p>
                                </Link>
                              </li>
                            </>

                            <li className="nav-item">
                              <Link className="nav-link" to="/receiveTransfert">
                                <i className="far fa-circle nav-icon" />
                                <p>Gestion des transferts</p>
                              </Link>
                            </li>
                          </ul>
                        </li>
                        <li className="nav-item">
                          <div
                            className="nav-link"
                            onClick={createToggleMenuHandler(
                              menuState,
                              setMenuState,
                              "Purchase"
                            )}
                          >
                            <i
                              className="nav-icon fas fa-cart-arrow-down"
                            // style={{ fontSize: "22px" }}
                            ></i>
                            <p>
                              Achats
                              <i
                                className={`right fas fa-angle-${menuState["Purchase"] ? "down" : "left"
                                  }`}
                              />
                            </p>
                          </div>

                          <ul
                            className={`nav nav-treeview ${menuState["Purchase"] ? "show" : ""
                              }`}
                          >
                            <li className="nav-item">
                              <Link className="nav-link" to="/bonsDeCommande">
                                <i className="far fa-circle nav-icon" />
                                <p> Les bons de commande </p>
                              </Link>
                            </li>

                            <li className="nav-item">
                              <Link className="nav-link" to="/factures">
                                <i className="far fa-circle nav-icon" />
                                <p> Les factures </p>
                              </Link>
                            </li>

                            {(showElement.includes("PURCHASING_MANAGER") ||
                              showElement.includes("ADMIN") ||
                              showElement.includes("WAREHOUSE_MANAGER")) && (
                                <li className="nav-item">
                                  <Link
                                    className="nav-link"
                                    to="/receivePurchaseOrder"
                                  >
                                    <i className="far fa-circle nav-icon" />
                                    <p>Recevoir une commande </p>
                                  </Link>
                                </li>
                              )}
                          </ul>
                        </li>{" "}
                        <li className="nav-item">
                          <div
                            className="nav-link"
                            onClick={createToggleMenuHandler(
                              menuState,
                              setMenuState,
                              "Sale"
                            )}
                          >
                            <i
                              className="nav-icon fas fa-shopping-cart"
                            // style={{ fontSize: "22px" }}
                            ></i>

                            <p>
                              Ventes
                              <i
                                className={`right fas fa-angle-${menuState["Sale"] ? "down" : "left"
                                  }`}
                              />
                            </p>
                          </div>
                          <ul
                            className={`nav nav-treeview ${menuState["Sale"] ? "show" : ""
                              }`}
                          >
                                <li className="nav-item">
                                  <Link
                                    className="nav-link"
                                    to="/bonCommandeVente"
                                  >
                                    {/* <i className="far fa-circle nav-icon" /> */}
                                    <p> Les bons de commande </p>
                                  </Link>
                                </li>

                                {(showElement.includes("PURCHASING_MANAGER") ||
                                  showElement.includes("ADMIN")) && (
                                    <li className="nav-item">
                                      <Link className="nav-link" to="/allDevis">
                                        {/* <i className="far fa-circle nav-icon" /> */}
                                        <p>les devis</p>
                                      </Link>
                                    </li>
                                  )}

                                {(showElement.includes("PURCHASING_MANAGER") ||
                                  showElement.includes("ADMIN")) && (
                                    <li className="nav-item">
                                      <Link
                                        className="nav-link"
                                        to="/bonCommandeVente"
                                      >
                                        {/* <i className="far fa-circle nav-icon" /> */}
                                        <p> Les bons de commande </p>
                                      </Link>
                                    </li>
                                  )}

                                {(showElement.includes("PURCHASING_MANAGER") ||
                                  showElement.includes("ADMIN")) && (
                                    <li className="nav-item">
                                      <Link
                                        className="nav-link"
                                        to="/allFactureSell"
                                      >
                                        {/* <i className="far fa-circle nav-icon" /> */}
                                        <p> Les factures </p>
                                      </Link>
                                    </li>
                                  )}

<li className="nav-item">
  <Link className="nav-link" to="/suiviLivraisons">
    <p>Suivi des livraisons</p>
  </Link>
</li>
                                {(showElement.includes("PURCHASING_MANAGER") ||
                                  showElement.includes("ADMIN") ||
                                  showElement.includes(
                                    "WAREHOUSE_MANAGER"
                                  )) && (
                                    <li className="nav-item">
                                      <Link
                                        className="nav-link"
                                        to="/sendPurchaseOrder"
                                      >
                                        {/* <i className="far fa-circle nav-icon" /> */}
                                        <p>Sortir une commande </p>
                                      </Link>
                                    </li>
                                  )}
                                {(showElement.includes("PURCHASING_MANAGER") ||
                                  showElement.includes("ADMIN") ||
                                  showElement.includes(
                                    "WAREHOUSE_MANAGER"
                                  )) && (
                                    <li className="nav-item">
                                      <Link
                                        className="nav-link"
                                        to="/retourSalesOrder"
                                      >
                                        {/* <i className="far fa-circle nav-icon" /> */}
                                        <p>Retour de commande </p>
                                      </Link>
                                    </li>
                                  )}
                          </ul>
                        </li>{" "}
                        {/* <li className="nav-item">
                          <div
                            className="nav-link"
                            onClick={createToggleMenuHandler(
                              menuState,
                              setMenuState,
                              "Product"
                            )}
                          >
                            <i className="nav-icon fab fa-brands fa-product-hunt"></i>

                            <p>
                              Mes produits
                              <i
                                className={`right fas fa-angle-${menuState["Product"] ? "down" : "left"
                                  }`}
                              />
                            </p>
                          </div>
                          <ul
                            className={`nav nav-treeview ${menuState["Product"] ? "show" : ""
                              }`}
                          >
                            {(showElement.includes("PURCHASING_MANAGER") ||
                              showElement.includes("ADMIN") ||
                              showElement.includes("WAREHOUSE_MANAGER")) && (
                                <li className="nav-item">
                                  <Link to="/products" className="nav-link">
                                    <i className="far fa-circle nav-icon" />
                                    <p>Produits</p>
                                  </Link>
                                </li>
                              )}
                            {(showElement.includes("PURCHASING_MANAGER") ||
                              showElement.includes("ADMIN") ||
                              showElement.includes("WAREHOUSE_MANAGER")) && (
                                <li className="nav-item">
                                  <Link to="/Lots" className="nav-link">
                                    <i className="far fa-circle nav-icon" />
                                    <p>Lots</p>
                                  </Link>
                                </li>
                              )}

                            {(showElement.includes("PURCHASING_MANAGER") ||
                              showElement.includes("ADMIN") ||
                              showElement.includes("WAREHOUSE_MANAGER")) && (
                                <li className="nav-item">
                                  <Link to="/specificities" className="nav-link">
                                    <i className="far fa-circle nav-icon" />
                                    <p>Spécificités</p>
                                  </Link>
                                </li>
                              )}

                            {(showElement.includes("PURCHASING_MANAGER") ||
                              showElement.includes("ADMIN")) && (
                                <li className="nav-item">
                                  <Link to="/Brands" className="nav-link">
                                    <i className="far fa-circle nav-icon" />
                                    <p>Les marques</p>
                                  </Link>
                                </li>
                              )}
                            {(showElement.includes("PURCHASING_MANAGER") ||
                              showElement.includes("ADMIN")) && (
                                <li className="nav-item">
                                  <Link to="/families" className="nav-link">
                                    <i className="far fa-circle nav-icon" />
                                    <p>Les familles</p>
                                  </Link>
                                </li>
                              )}
                            {(showElement.includes("PURCHASING_MANAGER") ||
                              showElement.includes("ADMIN")) && (
                                <li className="nav-item">
                                  <Link to="/subFamilies" className="nav-link">
                                    <i className="far fa-circle nav-icon" />
                                    <p>Les sous familles</p>
                                  </Link>
                                </li>
                              )}

                            {(showElement.includes("PURCHASING_MANAGER") ||
                              showElement.includes("ADMIN")) && (
                                <li className="nav-item">
                                  <Link to="/categories" className="nav-link">
                                    <i className="far fa-circle nav-icon" />
                                    <p>Les catégories</p>
                                  </Link>
                                </li>
                              )}
                          </ul>
                        </li> */}
                        {/* <li className="nav-item">
                          <div
                            className="nav-link"
                            onClick={createToggleMenuHandler(
                              menuState,
                              setMenuState,
                              "Marketing"
                            )}
                          >
                            <i className="nav-icon fas fa-chart-pie"></i>

                            <p>
                              Marketing
                              <i
                                className={`right fas fa-angle-${menuState["Marketing"] ? "down" : "left"
                                  }`}
                              />
                            </p>
                          </div>
                          <ul
                            className={`nav nav-treeview ${menuState["Marketing"] ? "show" : ""
                              }`}
                          >
                            {(showElement.includes("PURCHASING_MANAGER") ||
                              showElement.includes("ADMIN")) && (
                                <>
                                  <li className="nav-item">
                                    <Link className="nav-link" to="/dashboard">
                                      <i className="far fa-circle nav-icon" />
                                      <p>Statistiques</p>
                                    </Link>
                                  </li>
                                  <li className="nav-item">
                                    <Link className="nav-link" to="/ListeOffres">
                                      <i className="far fa-circle nav-icon" />
                                      <p>Offres</p>
                                    </Link>
                                  </li>
                                  <li className="nav-item">
                                    <Link
                                      className="nav-link"
                                      to="/PagePublication"
                                    >
                                      <i className="far fa-circle nav-icon" />
                                      <p>Publication</p>
                                    </Link>
                                  </li>
                                  <li className="nav-item">
                                    <Link className="nav-link" to="/Campagne">
                                      <i className="far fa-circle nav-icon" />
                                      <p>Campagne</p>
                                    </Link>
                                  </li>
                                  <li className="nav-item">
                                    <Link className="nav-link" to="/Client">
                                      <i className="far fa-circle nav-icon" />
                                      <p>Client</p>
                                    </Link>
                                  </li>
                                </>
                              )}
                          </ul>
                        </li> */}
                      </>
                    )}
                  {showElement.includes("EMPLOYEE_RH") &&
                    !showElement.includes("COMMERCIAL") && (
                      <>
                        <li className="nav-item">
                          <Link to="/employeDashboard" className="nav-link">
                            <i className="far fa-circle nav-icon"></i>{" "}
                            <p>Dashboard</p>
                          </Link>
                        </li>
                        <li className="nav-item">
                          <Link to="/leaverequestslist" className="nav-link">
                            <i className="far fa-circle nav-icon"></i>{" "}
                            <p>Mes demandes de Congé</p>
                          </Link>
                        </li>
                        {/* <li className="nav-item">
                        <Link to="/employeeCrew" className="nav-link">
                          <i className="nav-icon far fa-circle"></i>
                          <p>Mon équipe</p>
                        </Link>
                      </li> */}
                      </>
                    )}
                  {(showElement.includes("SUPER_ADMIN") || showElement.includes("ADMIN")) && (
                    <li className="nav-item">
                      <Link to="/support" className="nav-link">
                        <i className="nav-icon far fa-life-ring"></i>
                        <p>Support</p>
                      </Link>
                    </li>
                  )}
                  {showElement.includes("SUPER_ADMIN") && (
                    <>
                      <li className="nav-item">
                        <Link to="/adminSociete" className="nav-link">
                          <i className="nav-icon fas fa-city"></i>
                          <p>Entreprises clientes</p>
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link to="/paiementsAbonnement" className="nav-link">
                          <i className="nav-icon fas fa-money-check-alt"></i>
                          <p>Paiements d'abonnement</p>
                        </Link>
                      </li>

                      <li className="nav-item">
                        <Link to="/allAdminsAccount" className="nav-link">
                          <i
                            className="nav-icon material-icons"
                            style={{ fontSize: "25px" }}
                          >
                            {" "}
                            account_circle
                          </i>
                          <p>Client</p>
                        </Link>
                      </li>
                    </>
                  )}

                  {showElement.includes("FINANCIAL_OFFICER") && (
                    <li className="nav-item">
                      <div
                        className="nav-link"
                        onClick={createToggleMenuHandler(
                          menuState,
                          setMenuState,
                          "Finance"
                        )}
                      >
                        <i className="fas fa-money-bill-wave"></i>{" "}
                        <p>
                          Comptes et paiements
                          <i
                            className={`right fas fa-angle-${menuState["Finance"] ? "down" : "left"
                              }`}
                          />
                        </p>
                      </div>
                      <ul
                        className={`nav nav-treeview ${menuState["Finance"] ? "show" : ""
                          }`}
                      >
                        <li className="nav-item">
                          <div
                            className="nav-link"
                            onClick={createToggleMenuHandler(
                              menuState,
                              setMenuState,
                              "Accounts"
                            )}
                          >
                            <i className="far fa-circle nav-icon"></i>
                            <p>
                              Les Comptes
                              <i
                                className={`right fas fa-angle-${menuState["Accounts"] ? "down" : "left"
                                  }`}
                              ></i>
                            </p>
                          </div>
                          <ul
                            className={`nav nav-treeview ${menuState["Accounts"] ? "show" : ""
                              }`}
                          >
                            <li className="nav-item">
                              <Link
                                to="/allBanqueAccounts"
                                className="nav-link"
                              >
                                <p>Détails des comptes</p>
                              </Link>
                            </li>
                            <li className="nav-item">
                              <Link
                                to="/transfertsEntreCompte"
                                className="nav-link"
                              >
                                <p>Transfert </p>
                              </Link>
                            </li>
                            <li className="nav-item">
                              <Link to="/listBordereau" className="nav-link">
                                <p>Bordereau</p>
                              </Link>
                            </li>
                            <li className="nav-item">
                              <Link
                                to="/allAgendaPayement"
                                className="nav-link"
                              >
                                <p>Agenda des payements </p>
                              </Link>
                            </li>
                            {/* <li className="nav-item">
                              <div
                                className="nav-link"
                                onClick={createToggleMenuHandler(
                                  menuState,
                                  setMenuState,
                                  "wallets"
                                )}
                              >
                                <i class="fas fa-wallet nav-icon"></i>
                                <p>
                                  Les Wallets
                                  <i
                                    className={`right fas fa-angle-${menuState["wallets"] ? "down" : "left"
                                      }`}
                                  ></i>
                                </p>
                              </div>
                              <ul
                                className={`nav nav-treeview ${menuState["wallets"] ? "show" : ""
                                  }`}
                              >
                                <li className="nav-item">
                                  <Link to="/walletClient" className="nav-link">
                                    <p>Wallets Clients </p>
                                  </Link>
                                </li>
                                <li className="nav-item">
                                  <Link
                                    to="/walletFournisseur"
                                    className="nav-link"
                                  >
                                    <p>Wallets Fournisseurs </p>
                                  </Link>
                                </li>
                              </ul>
                            </li> */}
                          </ul>
                        </li>

                        <li className="nav-item">
                          <div
                            className="nav-link"
                            onClick={createToggleMenuHandler(
                              menuState,
                              setMenuState,
                              "FinancePurchase"
                            )}
                          >
                            <i className="far fa-circle nav-icon"></i>
                            <p>
                              Achats
                              <i
                                className={`right fas fa-angle-${menuState["FinancePurchase"] ? "down" : "left"
                                  }`}
                              ></i>
                            </p>
                          </div>
                          <ul
                            className={`nav nav-treeview ${menuState["FinancePurchase"] ? "show" : ""
                              }`}
                          >
                            <li className="nav-item">
                              <Link to="/listSocieteAchat" className="nav-link">
                                <p>Payement</p>
                              </Link>
                            </li>
                            <li className="nav-item">
                              <Link
                                to="/listFournisseurSolde"
                                className="nav-link"
                              >
                                <p>Solde</p>
                              </Link>
                            </li>
                          </ul>
                        </li>

                        <li className="nav-item">
                          <div
                            className="nav-link"
                            onClick={createToggleMenuHandler(
                              menuState,
                              setMenuState,
                              "FinanceSales"
                            )}
                          >
                            <i className="far fa-circle nav-icon"></i>
                            <p>
                              Ventes
                              <i
                                className={`right fas fa-angle-${menuState["FinanceSales"] ? "down" : "left"
                                  }`}
                              ></i>
                            </p>
                          </div>
                          <ul
                            className={`nav nav-treeview ${menuState["FinanceSales"] ? "show" : ""
                              }`}
                          >
                            <li className="nav-item">
                              <Link to="/listSocieteVente" className="nav-link">
                                <p>Payement</p>
                              </Link>
                            </li>

                            <li className="nav-item">
                              <Link to="/listClientSolde" className="nav-link">
                                <p>Solde</p>
                              </Link>
                            </li>
                          </ul>
                        </li>

                        {/* <li className="nav-item">
                          <div
                            className="nav-link"
                            onClick={createToggleMenuHandler(
                              menuState,
                              setMenuState,
                              "Salaires"
                            )}
                          >
                            <i className="far fa-circle nav-icon"></i>
                            <p>
                              Les Salaires
                              <i
                                className={`right fas fa-angle-${menuState["Salaires"] ? "down" : "left"
                                  }`}
                              ></i>
                            </p>
                          </div>
                          <ul
                            className={`nav nav-treeview ${menuState["Salaires"] ? "show" : ""
                              }`}
                          >
                            <li className="nav-item">
                              <Link to="/ajouterAvance" className="nav-link">
                                <p>Payement avance</p>
                              </Link>
                            </li>
                            <li className="nav-item">
                              <Link to="/ajouterSalaire" className="nav-link">
                                <p>Payement salaire </p>
                              </Link>
                            </li>
                            <li className="nav-item">
                              <Link to="/salairesPayement" className="nav-link">
                                <p>Historique </p>
                              </Link>
                            </li>
                            <li className="nav-item">
                              <div
                                className="nav-link"
                                onClick={createToggleMenuHandler(
                                  menuState,
                                  setMenuState,
                                  "SalaireFicheDePaies"
                                )}
                              >
                                <i className="far fa-circle nav-icon"></i>
                                <p>
                                  Les Fiches de paies
                                  <i
                                    className={`right fas fa-angle-${menuState["SalaireFicheDePaies"]
                                      ? "down"
                                      : "left"
                                      }`}
                                  ></i>
                                </p>
                              </div>
                              <ul
                                className={`nav nav-treeview ${menuState["SalaireFicheDePaies"] ? "show" : ""
                                  }`}
                              >
                                <li className="nav-item">
                                  <Link to="/ficheDePaie" className="nav-link">
                                    <p>Par présence </p>
                                  </Link>
                                </li>
                                <li className="nav-item">
                                  <Link
                                    to="/fichedepaieparsalaire"
                                    className="nav-link"
                                  >
                                    <p>Sur salaire </p>
                                  </Link>
                                </li>
                              </ul>
                            </li>
                          </ul>
                        </li> */}

                        <li className="nav-item">
                          <Link className="nav-link" to="/chargesEtat">
                            <i className="far fa-circle nav-icon" />
                            <p>Charges </p>
                          </Link>
                        </li>
                      </ul>
                    </li>
                  )}
                  {/* acces marketing */}
                  {showElement.includes("RESPONSABLE_MARKETING") && (
                    <>
                      <li className="nav-item">
                        <div
                          className="nav-link"
                          onClick={createToggleMenuHandler(
                            menuState,
                            setMenuState,
                            "Product"
                          )}
                        >
                          <i className="nav-icon fab fa-brands fa-product-hunt"></i>

                          <p>
                            Mes produits
                            <i
                              className={`right fas fa-angle-${menuState["Product"] ? "down" : "left"
                                }`}
                            />
                          </p>
                        </div>
                        <ul
                          className={`nav nav-treeview ${menuState["Product"] ? "show" : ""
                            }`}
                        >
                          <li className="nav-item">
                            <Link to="/products" className="nav-link">
                              <i className="far fa-circle nav-icon" />
                              <p>Produits</p>
                            </Link>
                          </li>
                          <li className="nav-item">
                            <Link to="/specificities" className="nav-link">
                              <i className="far fa-circle nav-icon" />
                              <p>Spécificités</p>
                            </Link>
                          </li>

                          <li className="nav-item">
                            <Link to="/Brands" className="nav-link">
                              <i className="far fa-circle nav-icon" />
                              <p>Les marques</p>
                            </Link>
                          </li>

                          <li className="nav-item">
                            <Link to="/families" className="nav-link">
                              <i className="far fa-circle nav-icon" />
                              <p>Les familles</p>
                            </Link>
                          </li>

                          <li className="nav-item">
                            <Link to="/subFamilies" className="nav-link">
                              <i className="far fa-circle nav-icon" />
                              <p>Les sous familles</p>
                            </Link>
                          </li>

                          <li className="nav-item">
                            <Link to="/categories" className="nav-link">
                              <i className="far fa-circle nav-icon" />
                              <p>Les catégories</p>
                            </Link>
                          </li>
                        </ul>
                      </li>
                      <li className="nav-item">
                        <div
                          className="nav-link"
                          onClick={createToggleMenuHandler(
                            menuState,
                            setMenuState,
                            "Purchase"
                          )}
                        >
                          <i
                            className="nav-icon fas fa-cart-arrow-down"
                          // style={{ fontSize: "22px" }}
                          ></i>
                          <p>
                            Achats
                            <i
                              className={`right fas fa-angle-${menuState["Purchase"] ? "down" : "left"
                                }`}
                            />
                          </p>
                        </div>

                        <ul
                          className={`nav nav-treeview ${menuState["Purchase"] ? "show" : ""
                            }`}
                        >
                          <li className="nav-item">
                            <Link className="nav-link" to="/factures">
                              <i className="far fa-circle nav-icon" />
                              <p> Les factures </p>
                            </Link>
                          </li>
                        </ul>
                      </li>
                      <li className="nav-item">
                        <div
                          className="nav-link"
                          onClick={createToggleMenuHandler(
                            menuState,
                            setMenuState,
                            "Marketing"
                          )}
                        >
                          <i className="nav-icon fas fa-chart-pie"></i>

                          <p>
                            Marketing
                            <i
                              className={`right fas fa-angle-${menuState["Marketing"] ? "down" : "left"
                                }`}
                            />
                          </p>
                        </div>
                        <ul
                          className={`nav nav-treeview ${menuState["Marketing"] ? "show" : ""
                            }`}
                        >
                          {(showElement.includes("PURCHASING_MANAGER") ||
                            showElement.includes("RESPONSABLE_MARKETING") ||
                            showElement.includes("ADMIN")) && (
                              <>
                                {" "}
                                {/* <li className="nav-item">
                                  <Link className="nav-link" to="/dashboard">
                                    <i className="far fa-circle nav-icon" />
                                    <p>Statistiques</p>
                                  </Link>
                                </li> */}
                                <li className="nav-item">
                                  <Link className="nav-link" to="/ListeOffres">
                                    <i className="far fa-circle nav-icon" />
                                    <p>Offres</p>
                                  </Link>
                                </li>
                                <li className="nav-item">
                                  <Link className="nav-link" to="/Campagne">
                                    <i className="far fa-circle nav-icon" />
                                    <p>Campagne</p>
                                  </Link>
                                </li>
                                <li className="nav-item">
                                  <Link className="nav-link" to="/Client">
                                    <i className="far fa-circle nav-icon" />
                                    <p>Client</p>
                                  </Link>
                                </li>
                                <li className="nav-item">
                                  <Link
                                    className="nav-link"
                                    to="/PagePublication"
                                  >
                                    <i className="far fa-circle nav-icon" />
                                    <p>Publication</p>
                                  </Link>
                                </li>
                              </>
                            )}
                        </ul>
                      </li>
                    </>
                  )}

                  {showElement.includes("CHEF_CHAINE") && (
                    <li className="nav-item">
                      <Link to="/OperationsJour" className="nav-link">
                        <i className="far fa-circle nav-icon"></i>{" "}
                        <p>Opération du jour</p>
                      </Link>
                    </li>
                  )}
                  {showElement.includes("CHEF_CHAINE") && (
                    <li className="nav-item">
                      <Link to="/workstations" className="nav-link">
                        <i className="far fa-circle nav-icon"></i>{" "}
                        <p>Station de travail</p>
                      </Link>
                    </li>
                  )}

                  {showElement.includes("CHEF_CHAINE") && (
                    <li className="nav-item">
                      <Link
                        to="/production-orders"
                        className="nav-link"
                      >
                        <i className="far fa-circle nav-icon"></i>{" "}

                        <p>Ordre de Production</p>
                      </Link>
                    </li>
                  )}


                  {showElement.includes("CHEF_CHAINE") && (

                    <li className="nav-item">
                      <div
                        className="nav-link"
                        onClick={createToggleMenuHandler(
                          menuState,
                          setMenuState,
                          "Depot"
                        )}
                      >
                        <i className="nav-icon fas fa-solid fa-warehouse"></i>
                        <p>
                          Gestion de stock
                          <i
                            className={`right fas fa-angle-${menuState["Depot"] ? "down" : "left"
                              }`}
                          />
                        </p>
                      </div>
                      <ul
                        className={`nav nav-treeview ${menuState["Depot"] ? "show" : ""
                          }`}
                      >
                        <li className="nav-item">
                          <Link
                            to="/warehouses"
                            className="nav-link"
                          >
                            <i className="far fa-circle nav-icon" />
                            <p>Dépôts</p>
                          </Link>
                        </li>
                        <li className="nav-item">
                          <Link to="/rfidTransfert" className="nav-link">
                            <i className="far fa-circle nav-icon" />
                            <p>RFID</p>
                          </Link>
                        </li>
                        <li className="nav-item">
                          <Link className="nav-link" to="/inventaires">
                            <i className="far fa-circle nav-icon" />
                            <p>Inventaire</p>
                          </Link>
                        </li>
                        <li className="nav-item">
                          <Link
                            className="nav-link"
                            to="/transfertsByWarehouseManager"
                          >
                            <i className="far fa-circle nav-icon" />
                            <p>Les transferts</p>
                          </Link>
                        </li>
                        <li className="nav-item">
                          <Link className="nav-link" to="/receiveTransfert">
                            <i className="far fa-circle nav-icon" />
                            <p>Gestion des transferts</p>
                          </Link>
                        </li>
                      </ul>
                    </li>
                  )}

                  {/* {(showElement.includes("PURCHASING_MANAGER") ||
                    showElement.includes("WAREHOUSE_MANAGER")) &&
                    !showElement.includes("COMMERCIAL") && (
                      <>
                        {" "}
                        <li className="nav-item">
                          <a href="#" className="nav-link">
                            <i className="nav-icon fab fa-brands fa-product-hunt"></i>

                            <p>
                              Mes produits
                              <i className="right fas fa-angle-left" />
                            </p>
                          </a>
                          <ul className="nav nav-treeview">
                            {(showElement.includes("PURCHASING_MANAGER") ||
                              showElement.includes("ADMIN") ||
                              showElement.includes("WAREHOUSE_MANAGER")) && (
                                <li className="nav-item">
                                  <Link to="/products" className="nav-link">
                                    <i className="far fa-circle nav-icon" />
                                    <p>Produits</p>
                                  </Link>
                                </li>
                              )}
                            {(showElement.includes("PURCHASING_MANAGER") ||
                              showElement.includes("ADMIN") ||
                              showElement.includes("WAREHOUSE_MANAGER")) && (
                                <li className="nav-item">
                                  <Link to="/Lots" className="nav-link">
                                    <i className="far fa-circle nav-icon" />
                                    <p>Lots</p>
                                  </Link>
                                </li>
                              )}

                            {(showElement.includes("PURCHASING_MANAGER") ||
                              showElement.includes("ADMIN") ||
                              showElement.includes("WAREHOUSE_MANAGER")) && (
                                <li className="nav-item">
                                  <Link to="/specificities" className="nav-link">
                                    <i className="far fa-circle nav-icon" />
                                    <p>Spécificités</p>
                                  </Link>
                                </li>
                              )}

                            {(showElement.includes("PURCHASING_MANAGER") ||
                              showElement.includes("ADMIN")) && (
                                <li className="nav-item">
                                  <Link to="/Brands" className="nav-link">
                                    <i className="far fa-circle nav-icon" />
                                    <p>Les marques</p>
                                  </Link>
                                </li>
                              )}
                            {(showElement.includes("PURCHASING_MANAGER") ||
                              showElement.includes("ADMIN")) && (
                                <li className="nav-item">
                                  <Link to="/families" className="nav-link">
                                    <i className="far fa-circle nav-icon" />
                                    <p>Les familles</p>
                                  </Link>
                                </li>
                              )}
                            {(showElement.includes("PURCHASING_MANAGER") ||
                              showElement.includes("ADMIN")) && (
                                <li className="nav-item">
                                  <Link to="/subFamilies" className="nav-link">
                                    <i className="far fa-circle nav-icon" />
                                    <p>Les sous familles</p>
                                  </Link>
                                </li>
                              )}

                            {(showElement.includes("PURCHASING_MANAGER") ||
                              showElement.includes("ADMIN")) && (
                                <li className="nav-item">
                                  <Link to="/categories" className="nav-link">
                                    <i className="far fa-circle nav-icon" />
                                    <p>Les catégories</p>
                                  </Link>
                                </li>
                              )}
                          </ul>
                        </li>
                        <li className="nav-item">
                          <a href="" className="nav-link">
                            <i className="nav-icon fas fa-solid fa-warehouse"></i>
                            <p>
                              Gestion de stock
                              <i className="fas fa-angle-left right" />
                            </p>
                          </a>
                          <ul className="nav nav-treeview">
                            {(showElement.includes("PURCHASING_MANAGER") ||
                              showElement.includes("WAREHOUSE_MANAGER") ||
                              showElement.includes("ADMIN")) && (
                                <li className="nav-item">
                                  <Link to="/warehouses" className="nav-link">
                                    <i className="far fa-circle nav-icon" />
                                    <p>Dépôts</p>
                                  </Link>
                                </li>
                              )}
                              {(showElement.includes("WAREHOUSE_MANAGER") ||
                                showElement.includes("ADMIN")) && (
                                  <li className="nav-item">
                                    <Link to="/rfidTransfert" className="nav-link">
                                      <i className="far fa-circle nav-icon" />
                                      <p>RFID</p>
                                    </Link>
                                  </li>
                                )}

                            {(showElement.includes("WAREHOUSE_MANAGER") ||
                              showElement.includes("ADMIN")) && (
                                <>
                                  <li className="nav-item">
                                    <Link
                                      className="nav-link"
                                      to="/transfertsByWarehouseManager"
                                    >
                                      <i className="far fa-circle nav-icon" />
                                      <p>Les transferts</p>
                                    </Link>
                                  </li>

                                  
                                </>
                              )}

                           
                          </ul>
                        </li>
                        <li className="nav-item">
                          <a href="#" className="nav-link">
                            <i
                              className="nav-icon fas fa-cart-arrow-down"
                            ></i>
                            <p>
                              Achats
                              <i className="fas fa-angle-left right" />
                            </p>
                          </a>

                          <ul className="nav nav-treeview">
                            {(showElement.includes("PURCHASING_MANAGER") ||
                              showElement.includes("ADMIN")) && (
                                <li className="nav-item">
                                  <Link className="nav-link" to="/taxes">
                                    <i className="far fa-circle nav-icon " />
                                    <p>Taxes / Charges</p>
                                  </Link>
                                </li>
                              )}
                            {(showElement.includes("PURCHASING_MANAGER") ||
                              showElement.includes("ADMIN")) && (
                                <li className="nav-item">
                                  <Link className="nav-link" to="/allQuotation">
                                    <i className="far fa-circle nav-icon" />
                                    <p>les devis</p>
                                  </Link>
                                </li>
                              )}

                            {(showElement.includes("PURCHASING_MANAGER") ||
                              showElement.includes("ADMIN")) && (
                                <li className="nav-item">
                                  <Link className="nav-link" to="/bonsDeCommande">
                                    <i className="far fa-circle nav-icon" />
                                    <p> Les bons de commande </p>
                                  </Link>
                                </li>
                              )}

                            {(showElement.includes("PURCHASING_MANAGER") ||
                              showElement.includes("ADMIN")) && (
                                <li className="nav-item">
                                  <Link className="nav-link" to="/factures">
                                    <i className="far fa-circle nav-icon" />
                                    <p> Les factures </p>
                                  </Link>
                                </li>
                              )}

                            {(showElement.includes("PURCHASING_MANAGER") ||
                              showElement.includes("ADMIN") ||
                              showElement.includes("WAREHOUSE_MANAGER")) &&
                              !showElement.includes("COMMERCIAL") && (
                                <li className="nav-item">
                                  <Link
                                    className="nav-link"
                                    to="/receivePurchaseOrder"
                                  >
                                    <i className="far fa-circle nav-icon" />
                                    <p>Recevoir une commande </p>
                                  </Link>
                                </li>
                              )}

                          </ul>
                        </li>{" "}
                        <li className="nav-item">
                          <a href="#" className="nav-link">
                            <i className="nav-icon fas fa-shopping-cart"></i>

                            <p>
                              Ventes
                              <i className="fas fa-angle-left right" />
                            </p>
                          </a>
                          <ul className="nav nav-treeview">
                                <li className="nav-item">
                                  <Link className="nav-link" to="/productSell">
                                    <p>Prix de vente</p>
                                  </Link>
                                </li>

                                <li className="nav-item">
                                  <Link className="nav-link" to="/allDevis">
                                    <p>les devis</p>
                                  </Link>
                                </li>

                                <li className="nav-item">
                                  <Link
                                    className="nav-link"
                                    to="/bonCommandeVente"
                                  >
                                    <p> Les bons de commande </p>
                                  </Link>
                                </li>

                                <li className="nav-item">
                                  <Link
                                    className="nav-link"
                                    to="/allFactureSell"
                                  >
                                    <p> Les factures </p>
                                  </Link>
                                </li>

<li className="nav-item">
  <Link className="nav-link" to="/suiviLivraisons">
    <p>Suivi des livraisons</p>
  </Link>
</li>
                                <li className="nav-item">
                                  <Link
                                    className="nav-link"
                                    to="/sendPurchaseOrder"
                                  >
                                    <p>Sortir une commande </p>
                                  </Link>
                                </li>

                                <li className="nav-item">
                                  <Link
                                    className="nav-link"
                                    to="/retourSalesOrder"
                                  >
                                    <p>Retour de commande </p>
                                  </Link>
                                </li>
                            <li className="nav-item">
                              <div className="nav-link">
                                <i className="far fa-circle nav-icon"></i>
                                <p>
                                  Vente B2C
                                  <i className="right fas fa-angle-left"></i>
                                </p>
                              </div>
                              <ul className="nav nav-treeview">
                                <li className="nav-item">
                                  <Link className="nav-link" to="/caisses">
                                    <i className="far fa-star nav-icon"></i>
                                    <p>Caisses</p>
                                  </Link>
                                </li>

                                <li className="nav-item">
                                  <Link className="nav-link" to="/magasins">
                                    <i className="far fa-star nav-icon"></i>
                                    <p>Magasins</p>
                                  </Link>
                                </li>
                              </ul>
                            </li>
                          </ul>
                        </li>{" "}
                        <li className="nav-item">
                          <a href="#" className="nav-link">
                            <i className="nav-icon fas fa-chart-pie"></i>

                            <p>
                              Marketing
                              <i className="fas fa-angle-left right" />
                            </p>
                          </a>
                          <ul className="nav nav-treeview">
                            {(showElement.includes("PURCHASING_MANAGER") ||
                              showElement.includes("ADMIN")) && (
                                <li className="nav-item">
                                  <Link className="nav-link" to="/dashboard">
                                    <i className="far fa-circle nav-icon" />
                                    <p>Statistiques</p>
                                  </Link>
                                </li>
                              )}
                          </ul>
                          <ul className="nav nav-treeview">
                            {(showElement.includes("PURCHASING_MANAGER") ||
                              showElement.includes("ADMIN")) && (
                                <li className="nav-item">
                                  <Link className="nav-link" to="/ListeOffres">
                                    <i className="far fa-circle nav-icon" />
                                    <p>Offres</p>
                                  </Link>
                                </li>
                              )}
                          </ul>
                          <ul className="nav nav-treeview">
                            {(showElement.includes("PURCHASING_MANAGER") ||
                              showElement.includes("ADMIN")) && (
                                <li className="nav-item">
                                  <Link className="nav-link" to="/Campagne">
                                    <i className="far fa-circle nav-icon" />
                                    <p>Campagne</p>
                                  </Link>
                                </li>
                              )}
                          </ul>
                          <ul className="nav nav-treeview">
                            {(showElement.includes("PURCHASING_MANAGER") ||
                              showElement.includes("ADMIN")) && (
                                <li className="nav-item">
                                  <Link className="nav-link" to="/Client">
                                    <i className="far fa-circle nav-icon" />
                                    <p>Client</p>
                                  </Link>
                                </li>
                              )}
                          </ul>
                          <ul className="nav nav-treeview">
                            {(showElement.includes("PURCHASING_MANAGER") ||
                              showElement.includes("ADMIN")) && (
                                <li className="nav-item">
                                  <Link
                                    className="nav-link"
                                    to="/PagePublication"
                                  >
                                    <i className="far fa-circle nav-icon" />
                                    <p>Publication</p>
                                  </Link>
                                </li>
                              )}
                          </ul>
                        </li>
                        <li className="nav-item">
                          <a href="#" className="nav-link">
                            <i className="nav-icon fas fa-users"></i>
                            <p>
                              Ressources humaines
                              <i className="fas fa-angle-left right" />
                            </p>
                          </a>

                          <ul className="nav nav-treeview">
                            {(showElement.includes("PURCHASING_MANAGER") ||
                              showElement.includes("ADMIN")) && (
                                <>
                                  <li className="nav-item">
                                    <Link className="nav-link" to="/dashboardRH">
                                      <i className="far fa-circle nav-icon" />
                                      <p>Statistiques</p>
                                    </Link>
                                  </li>
                                  <li className="nav-item">
                                    <Link to="/employeeList" className="nav-link">
                                      <i className="far fa-circle nav-icon"></i>
                                      <p>Mes employés</p>
                                    </Link>
                                  </li>
                                  <li className="nav-item">
                                    <Link to="/contractList" className="nav-link">
                                      <i className="far fa-circle nav-icon"></i>
                                      <p>Mes contrats</p>
                                    </Link>
                                  </li>
                                  <li className="nav-item">
                                    <Link
                                      to="/department_list"
                                      className="nav-link"
                                    >
                                      <i className="far fa-circle nav-icon"></i>
                                      <p>Mes Départements</p>
                                    </Link>
                                  </li>
                                  <li className="nav-item">
                                    <Link to="/crewList" className="nav-link">
                                      <i className="far fa-circle nav-icon"></i>
                                      <p>Mes équipes</p>
                                    </Link>
                                  </li>
                                  <li className="nav-item">
                                    <Link
                                      to="/mission_order"
                                      className="nav-link"
                                    >
                                      <i className="far fa-circle nav-icon"></i>
                                      <p>Mes ordres de mission</p>
                                    </Link>
                                  </li>
                                  <li className="nav-item">
                                    <Link
                                      to="/mission_interne"
                                      className="nav-link"
                                    >
                                      <i className="far fa-circle nav-icon"></i>
                                      <p>Mes Contrats de partage</p>
                                    </Link>
                                  </li>
                                  <li className="nav-item">
                                    <Link
                                      to="/Attendance_list"
                                      className="nav-link"
                                    >
                                      <i className="far fa-circle nav-icon"></i>
                                      <p>Présence</p>
                                    </Link>
                                  </li>
                                  <li className="nav-item">
                                    <Link
                                      to="/LeaveRequests"
                                      className="nav-link"
                                    >
                                      <i className="far fa-circle nav-icon"></i>{" "}
                                      <p>Demandes de Congé</p>
                                    </Link>
                                  </li>

                                  <li className="nav-item">
                                    <div
                                      className="nav-link"
                                      onClick={createToggleMenuHandler(
                                        menuState,
                                        setMenuState,
                                        "RhSettings"
                                      )}
                                    >
                                      <i className="far fa-circle nav-icon"></i>
                                      <p>
                                        Paramétrage global
                                        <i
                                          className={`right fas fa-angle-${menuState["RhSettings"]
                                              ? "down"
                                              : "left"
                                            }`}
                                        ></i>
                                      </p>
                                    </div>
                                    <ul
                                      className={`nav nav-treeview ${menuState["RhSettings"] ? "show" : ""
                                        }`}
                                    >
                                      <li className="nav-item">
                                        <Link to="/postList" className="nav-link">
                                          <p>Les postes</p>
                                        </Link>
                                      </li>
                                      <li className="nav-item">
                                        <Link
                                          to="/contracttype"
                                          className="nav-link"
                                        >
                                          <p>Les types de contrat</p>
                                        </Link>
                                      </li>
                                      <li className="nav-item">
                                        <Link
                                          to="/primelist"
                                          className="nav-link"
                                        >
                                          <p>Les primes</p>
                                        </Link>
                                      </li>
                                      <li className="nav-item">
                                        <Link
                                          to="/LeaveTypeList"
                                          className="nav-link"
                                        >
                                          <p>Les types de congé</p>
                                        </Link>
                                      </li>
                                    </ul>
                                  </li>
                                  <li className="nav-item">
                                    <Link
                                      to="/employee/leaverequestslist"
                                      className="nav-link"
                                    >
                                      <i className="far fa-circle nav-icon"></i>{" "}
                                      <p>Mes demandes de Congé</p>
                                    </Link>
                                  </li>
                                </>
                              )}
                          </ul>
                        </li>
                      
                        {showElement.includes("ADMIN") && (
                          <li className="nav-item">
                            <a href="#" className="nav-link">
                              <i className=" nav-icon fa-solid fa-industry"></i>
                              <p>
                                Production
                                <i className="fas fa-angle-left right" />
                              </p>
                            </a>

                            <ul className="nav nav-treeview">
                              <li className="nav-item">
                                <a href="#" className="nav-link">
                                  <i className="far fa-circle nav-icon" />
                                  <p>
                                    Resources
                                    <i className="fas fa-angle-left right" />
                                  </p>
                                </a>
                                <ul className="nav nav-treeview">
                                  <li className="nav-item">
                                    <Link to="/uom" className="nav-link">
                                      <p>Unité de mesure</p>
                                    </Link>
                                  </li>
                                  <li className="nav-item">
                                    <Link
                                      to="/workstations"
                                      className="nav-link"
                                    >
                                      <p>Station de travail</p>
                                    </Link>
                                  </li>
                                  <li className="nav-item">
                                    <Link to="/operations" className="nav-link">
                                      <p>Opération</p>
                                    </Link>
                                  </li>
                                  <li className="nav-item">
                                    <Link to="/bom" className="nav-link">
                                      <p>BOM</p>
                                    </Link>
                                  </li>
                                </ul>
                              </li>

                              <li className="nav-item">
                                <a href="#" className="nav-link">
                                  <i className="far fa-circle nav-icon" />
                                  <p>
                                    Production
                                    <i className="fas fa-angle-left right" />
                                  </p>
                                </a>
                                <ul className="nav nav-treeview">
                                  <li className="nav-item">
                                    <Link
                                      to="/production-orders"
                                      className="nav-link"
                                    >
                                      <p>Ordre de Production</p>
                                    </Link>
                                  </li>
                                  <li className="nav-item">
                                    <Link
                                      to="/sendProductionOrder"
                                      className="nav-link"
                                    >
                                      <p>Matiere premiere</p>
                                    </Link>
                                  </li>
                                  <li className="nav-item">
                                    <Link
                                      to="/getFinalProductionOrder"
                                      className="nav-link"
                                    >
                                      <p>Produit fini</p>
                                    </Link>
                                  </li>
                                
                                </ul>
                              </li>
                            </ul>
                          </li>
                        )}
                      </>
                    )} */}
                  {showElement.includes("USER_B2B") && (
                    <>
                      <li className="nav-item">
                        <a href="#" className="nav-link">
                          <i className="nav-icon fas fa-solid fa-building"></i>
                          <p>
                            Clients et fournisseurs
                            <i className="right fas fa-angle-left" />
                          </p>
                        </a>

                        <ul className="nav nav-treeview">
                          <li className="nav-item">
                            <Link to="/tiers" className="nav-link">
                              <i className="far fa-circle nav-icon" />
                              <p>Tiers</p>
                            </Link>
                          </li>
                        </ul>
                      </li>
                      <li className="nav-item">
                        <a href="#" className="nav-link">
                          <i
                            className="nav-icon fas fa-shopping-cart"
                          // style={{ fontSize: "22px" }}
                          ></i>

                          <p>
                            Ventes
                            <i className="fas fa-angle-left right" />
                          </p>
                        </a>
                        <ul className="nav nav-treeview">
                          {showElement.includes("USER_B2B") && (
                            <li className="nav-item">
                              <Link className="nav-link" to="/allDevis">
                                <p>les devis</p>
                              </Link>
                            </li>
                          )}
                        </ul>
                      </li>
                    </>
                  )}
                  {showElement.includes("COMMERCIAL") && (
                    <>
                      <li className="nav-item">
                        <div
                          className="nav-link"
                          onClick={createToggleMenuHandler(
                            menuState,
                            setMenuState,
                            "Tiers"
                          )}
                        >
                          <i className="nav-icon fas fa-solid fa-building"></i>
                          <p>
                            Clients et fournisseurs
                            <i
                              className={`right fas fa-angle-${menuState["Tiers"] ? "down" : "left"
                                }`}
                            />
                          </p>
                        </div>

                        <ul
                          className={`nav nav-treeview ${menuState["Tiers"] ? "show" : ""
                            }`}
                        >
                          <li className="nav-item">
                            <Link to="/tiers" className="nav-link">
                              <i className="far fa-circle nav-icon" />
                              <p>Tiers</p>
                            </Link>
                          </li>
                        </ul>
                      </li>
                      <li className="nav-item">
                        <div
                          className="nav-link"
                          onClick={createToggleMenuHandler(
                            menuState,
                            setMenuState,
                            "Sale"
                          )}
                        >
                          <i className="nav-icon fas fa-shopping-cart"></i>

                          <p>
                            Ventes
                            <i
                              className={`right fas fa-angle-${menuState["Sale"] ? "down" : "left"
                                }`}
                            />
                          </p>
                        </div>
                        <ul
                          className={`nav nav-treeview ${menuState["Sale"] ? "show" : ""
                            }`}
                        >
                          <li className="nav-item">
                            <Link className="nav-link" to="/allDevis">
                              <p>les devis</p>
                            </Link>
                          </li>
                        </ul>
                      </li>

                      <li className="nav-item">
                        <div
                          className="nav-link"
                          onClick={createToggleMenuHandler(
                            menuState,
                            setMenuState,
                            "ClientCommercial"
                          )}
                        >
                          <i className="fas fa-money-bill-wave"></i>{" "}
                          <p>
                            Client
                            <i
                              className={`right fas fa-angle-${menuState["ClientCommercial"] ? "down" : "left"
                                }`}
                            />
                          </p>
                        </div>
                        {/* <ul
                          className={`nav nav-treeview ${menuState["ClientCommercial"] ? "show" : ""
                            }`}
                        >
                          <li className="nav-item">
                            <Link className="nav-link" to="/clientSoldeWallet">
                              <i className="far fa-circle nav-icon" />
                              <p>Wallet Solde </p>
                            </Link>
                          </li>
                        </ul> */}
                      </li>
                    </>
                  )}
                  {showElement.includes("DIRECTEUR_MAGASIN") && (
                    <>
                      <li className="nav-item">
                        <div
                          className="nav-link"
                          onClick={createToggleMenuHandler(
                            menuState,
                            setMenuState,
                            "Depot"
                          )}
                        >
                          <i className="nav-icon fas fa-solid fa-warehouse"></i>
                          <p>
                            Gestion de stock
                            <i
                              className={`right fas fa-angle-${menuState["Depot"] ? "down" : "left"
                                }`}
                            />
                          </p>
                        </div>
                        <ul
                          className={`nav nav-treeview ${menuState["Depot"] ? "show" : ""
                            }`}
                        >
                          <li className="nav-item">
                            <Link
                              to="/WarehousesManagers-directeur"
                              className="nav-link"
                            >
                              <i className="far fa-circle nav-icon" />
                              <p>Dépôts</p>
                            </Link>
                          </li>
                          <li className="nav-item">
                            <Link
                              className="nav-link"
                              to="/transfertsByWarehouseManager"
                            >
                              <i className="far fa-circle nav-icon" />
                              <p>Les transferts</p>
                            </Link>
                          </li>
                          <li className="nav-item">
                            <Link className="nav-link" to="/receiveTransfert">
                              <i className="far fa-circle nav-icon" />
                              <p>Gestion des transferts</p>
                            </Link>
                          </li>
                        </ul>
                      </li>
                      <li className="nav-item">
                        <Link className="nav-link" to="/productSell">
                          {/* <i className="far fa-circle nav-icon" /> */}
                          <p>Prix de vente</p>
                        </Link>
                      </li>

                      <li className="nav-item">
                        <Link className="nav-link" to="/magasins-directeur">
                          <i className="far fa-star nav-icon"></i>
                          {/* <i className="far fa-circle nav-icon" /> */}
                          <p>Magasins</p>
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link className="nav-link" to="/caisses-directeur">
                          <i className="far fa-star nav-icon"></i>
                          {/* <i className="far fa-circle nav-icon" /> */}
                          <p>Caisses</p>
                        </Link>
                      </li>
                      <li className="nav-item">
                        <div
                          className="nav-link"
                          onClick={createToggleMenuHandler(
                            menuState,
                            setMenuState,
                            "Finance"
                          )}
                        >
                          <i className="fas fa-money-bill-wave"></i>{" "}
                          <p>
                            Comptes et paiements
                            <i
                              className={`right fas fa-angle-${menuState["Finance"] ? "down" : "left"
                                }`}
                            />
                          </p>
                        </div>
                        <ul
                          className={`nav nav-treeview ${menuState["Finance"] ? "show" : ""
                            }`}
                        >
                          <li className="nav-item">
                            <div
                              className="nav-link"
                              onClick={createToggleMenuHandler(
                                menuState,
                                setMenuState,
                                "Accounts"
                              )}
                            >
                              <i className="far fa-circle nav-icon"></i>
                              <p>
                                Les Comptes
                                <i
                                  className={`right fas fa-angle-${menuState["Accounts"] ? "down" : "left"
                                    }`}
                                ></i>
                              </p>
                            </div>
                            <ul
                              className={`nav nav-treeview ${menuState["Accounts"] ? "show" : ""
                                }`}
                            >
                              <li className="nav-item">
                                <Link
                                  to="/allBanqueAccounts-directeur"
                                  className="nav-link"
                                >
                                  <p>Détails des comptes</p>
                                </Link>
                              </li>
                              <li className="nav-item">
                                <Link
                                  to="/alimenter-caisse"
                                  className="nav-link"
                                >
                                  <p>Alimenter caisse</p>
                                </Link>
                              </li>
                              
                            </ul>
                          </li>

                             <li className="nav-item">
                              <Link className="nav-link" to="/chargesEtat">
                                <i className="far fa-circle nav-icon" />
                                <p>Charges </p>
                              </Link>
                            </li>
                                 <li className="nav-item">
                              <Link className="nav-link" to="/payerTraite">
                                <i className="far fa-circle nav-icon" />
                                <p>Payer traite </p>
                              </Link>
                            </li>
                        </ul>
                      </li>
                    </>
                  )}
                </ul>
              </nav>
            )}
          </div>
        </aside>
        {props.children}

        <Footer />
      </div>
    </body>
  );
};
export default Menu;
